import { Box, Card, Grid, Typography } from "@mui/material";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import ProjectDashboardPie from "../ProjectDashboard/ProjectDashboardPie";
import ProjectDashboardCards from "../ProjectDashboard/ProjectDashboardCards";
import DashboardProjectCard from "../ProjectDashboard/DashboardProjectCard";
import ProjectDashboardCardDev from "../ProjectDashboard/ProjectDashboardCardDev";
import { useEffect, useState } from "react";
import ProjectDashboardProgress from "../ProjectDashboard/ProjectDashboardProgess";
import ProjectDashboardTable from "../ProjectDashboard/ProjectDashboardTable";
import { useLocation } from "react-router-dom";
import { BASE_URL } from "../Utils/Baseurl";
import axios from "axios";

const ProjectDashboard = () => {
  const location = useLocation();
  const { id } = location.state || {};
  const [projectData, setProjectData] = useState([]);
  const phaseData = projectData?.phase_progress || [];
  const currectPhase = projectData?.current_phase || [];
  const tableData = projectData?.resource_list || [];


  useEffect(() => {
    if (id) {
      fetchProjectDashbaord(id);
    }
  }, [id]);

  /**
   * Fetches a project's dashboard data from the API and updates the state with the retrieved data.
   * Retrieves the authentication token from session storage and includes it in the request headers.
   * Upon successful response, sets the projectData state with the fetched data.
   * Logs any errors encountered during the fetch operation.
   *
   * @param {number} projectId - The ID of the project to fetch
   */
  const fetchProjectDashbaord = async (projectId) => {
    try {
      const response = await axios.get(`${BASE_URL}api/projectdashboard/${projectId}/`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      setProjectData(response.data.data);

    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    }
  };

  return (
    <DashboardLayout>
      {
        projectData ? (
          <Grid container >
            <Grid size={{ xs: 12, md: 8, lg: 8 }} >
              <Grid container spacing={1}>
                <Grid size={{ xs: 12, md: 6, lg: 6 }} pl={2} >
                  <DashboardProjectCard
                    projectName={projectData.project_name}
                    projectCode={projectData.project_code}
                    manager={projectData.manager_name}
                    status={projectData.status}
                    priority={projectData.priority_level}
                    date="23rd April 2024"
                    progress={projectData.completion_percentage}
                    projectGulanar={projectData.resource_allocation || []}
                    startDate={projectData.start_date}
                    endDate={projectData.end_date}
                  />
                </Grid>

                <Grid size={{ xs: 12, md: 6, lg: 6 }}>
                  <ProjectDashboardPie projectData={projectData} />
                </Grid>

                <Grid size={{ xs: 12, md: 6, lg: 6 }} pl={2} >
                  <ProjectDashboardCardDev
                    currentPhase="Development"
                    resources={currectPhase} />
                </Grid>

                <Grid size={{ xs: 12, md: 6, lg: 6 }} >
                  <ProjectDashboardProgress progressData={projectData.progress_indicators} />
                </Grid>

                <Grid size={{ xs: 12, md: 12, lg: 12 }} px={2} >
                  <ProjectDashboardTable title="Resource List" resources={tableData} />
                </Grid>
              </Grid>
            </Grid>

            <Grid size={{ xs: 12, md: 4, lg: 4 }} px={1}>
              <Grid size={{ xs: 12, md: 6, lg: 12 }} >
                <Card
                  sx={{
                    borderRadius: 3,
                    boxShadow: 3,
                    height: "470px",
                    width: "95%",
                    display: "flex",
                    flexDirection: "column",
                    // p: 2,
                  }}
                >
                  {/* <CardContent sx={{ flex: "0 0 auto",  }}> */}
                  <Box sx={{ display: "flex", justifyContent: "space-between", p: 1 }}>
                    <Typography variant="body2" fontWeight="bold">
                      Phase Progress
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      flex: 1,
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 2,
                      // mt: 1,
                      p: 1,
                      overflowY: "auto",
                      scrollbarWidth: "none",
                      "&::-webkit-scrollbar": {
                        display: "none",
                      },
                    }}
                  >
                    {phaseData.map((phase, index) => (
                      <ProjectDashboardCards key={index} phase={phase} />
                    ))}
                  </Box>
                  {/* </CardContent> */}
                </Card>
              </Grid>
            </Grid>
          </Grid>
        ) : (
          <Box
            sx={{
              width: "100%",
              height: "80vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography variant="h6" color="textSecondary" sx={{ textAlign: "center", fontFamily: 'Aptos' }}>Loading...Wait for few seconds your data is getting ready</Typography>
          </Box>
        )
      }


    </DashboardLayout>
  )
}
export default ProjectDashboard;